/*=========================================================================================
  File Name: moduleBedTypeGetters.js
  Description: BedType Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: JHM SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
    
  };
  